/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgKeyAdd = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m17.364 3.586 4.243 4.242-1.415 1.415-2.828-2.829-2.121 2.122 2.121 2.12-1.414 1.415-2.121-2.121-1.215 1.214a6 6 0 1 1-1.522-1.307zM8 11a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm10 5v2h-2v2h2v2h2v-2h2v-2h-2v-2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgKeyAdd as KeyAdd };
